import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import InputMask from 'react-input-mask';

interface IFormProps {
  cart: object,
  removeService: object,
  loadCart: any,
  session_id: any
}
interface MyStates {
  ajaxLoaded: boolean,
  spinner: string,
  cart: object,
}
export default class CheckoutList extends React.Component<IFormProps, MyStates>{
  private total: number;
  private netTotal: number;

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: true,
      spinner: 'none',
      cart: this.props.cart,
    }

    this.total = 0
    this.netTotal = 0
    
  }

  private remove(id, date){

    console.log('remove service id: '+id);

    swal({
        title: "Biztos, hogy törli ezt a tételt a listáról?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {
          
          var ajax = new Ajax(window.location.origin + '/api/ordering/removeServiceFromCart');
          ajax.doPost({session_id: this.props.session_id, id: id, date: date}).then((response) => {
            if( response.status !== undefined && response.status === 'success' ){
              swal({
                title: response.message,
                icon: "success",
              });
            } else {
              swal({
                title: "Hiba történt!",
                text: response.message,
                icon: "error",
              });
            }
            this.props.loadCart()
          })
            
        }
    });
  }

  private getPrice(item){
    let price = 0
    
    if(item?.data?.add_vat == 'yes') {
      price = (item?.data?.price)*item?.quantity
      this.netTotal += price/item.data.vat;
    } else {
      price = item?.data?.price*item?.quantity
      this.netTotal += price;
    }
    this.total += price
    return price
  }

  public getNetPrice(item){
      return (
          <div style = {{textAlign:"center"}}>{this.getTotalFormat(item?.data?.add_vat == 'yes' ? (item?.data?.price)*item?.quantity / item?.data?.vat : (item?.data?.price)*item?.quantity)}</div>
      )
  }

  public render() {
    this.total = 0;
    this.netTotal = 0;
    return (
      <>
        <div className={"row item"} style = {{backgroundColor: "#bdbdbd"}}>
          <div className = "col-md-6"><h4>Szolgáltatások</h4></div>
          <div className = "col-md-3"><h4 style = {{textAlign:"center"}}>Nettó ár</h4></div>
          <div className = "col-md-1"><h4 style = {{textAlign:"center"}}>Áfa</h4></div>
          <div className = "col-md-2"><h4 style = {{float: "right"}}>Bruttó ár</h4></div>
        </div>
      {
        Object.keys(this.state.cart).map((i) => {
          let s = this.state.cart[i]
          let content = '';

          if(s?.data?.id != 45){
            content = (s?.date_formatted == '' ? null : s.date_formatted) ?? this.getPriceFormat(s?.data?.price, ' / '+ s?.data?.unit)
          }


          return (
            <div className="row item" key={'serviceitem_' + i}>

              <div className="item_container">
                <div className="col-md-6">
                  <div className="item_title">{s?.data?.name}</div>
                  <div style={{padding: '5px 0px', fontSize: '11px'}} className="item_content">{s?.data?.description}</div>
                  <div className="item_content">{content}</div>
                </div>
                <div className="col-md-3">
                  {this.getNetPrice(s)}
                </div>
                <div className="col-md-1">
                  <div className="item_content" style = {{textAlign:"center"}}>{s?.data?.add_vat == 'yes' ? '27%' : '-'}</div>
                </div>
                <div className="col-md-2">
                  <div className="item_price">{this.getTotalFormat( this.getPrice(s) )}</div>
                </div>
                <div style={{clear:'both'}}></div>
              </div>
              {
                s?.removable?
                <button type="button" className="btn btn-danger item_remove" onClick={() => this.remove(s?.data?.id, s?.date)}><i className="fa fa-trash"></i></button>
                :<></>
              }
            </div>
          )
        })
      }
      <hr />
        <div className={"row item"} style = {{backgroundColor: "#bdbdbd"}}>
          <div className = "col-md-6"><h4>Összesen:</h4></div>
          <div className = "col-md-3"><h4 style = {{textAlign:"center"}}>{this.getTotalFormat(this.netTotal)}</h4></div>
          <div className = "col-md-3"><h4 style = {{float: "right"}}>{this.getTotalFormat(this.total)}</h4></div>
        </div>
      </>
    )
  }

  private getPriceFormat(price, text = ''){

    if( price == 0 ){
      return <div className="price">Díjtalan</div>
    } else {
      return <div className="price">{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} Ft {text}</div>
    }
  }

  private getTotalFormat(price, text = ''){

    console.log(price);

    if( price == 0 ){
      return <span className="price">Díjtalan</span>
    } else {
      return <span className="price">{Math.round(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} Ft {text}</span>
    }
  }

}